<template lang="pug">
  div(
    @click.stop=""
    :class="{'always-open': alwaysOpen}"
  ).customSelect.e-suggestion-multiselect
    input(
      @focus="onFocus()"
      :class="hasError ? 'is-invalid customSelect__select' : 'customSelect__select'"
        :placeholder="placeholder"
        @click="onClick"
      v-model="searchedValue"
      :name="`${name}-search`"
        @keyup.enter.prevent.stop="onEnter"
        @input="onInput"
       :disabled="disabled"
    ref="suggestion"
    )

    template
      span(v-if="!disabled && alwaysOpen === false" @click="toggleList()").choose
      div(v-if="listOpened && !dontShowErrorInFinishComponent && error").customSelect__list.cuscroll.open.error-list
        ul
          li
            div
              div.small.partial-error.error {{error}}
      div(
        v-else-if="(alwaysOpen === true || (enableSelectAll === true && showListItems))"
      ).customSelect__list.cuscroll.open.select-all
        ul
          li(v-if="enableSelectAll === true")
            div(@click="selectAll()")
              span Выбрать все
            label.checked
              input.checkbox(@click="selectAll()" :disabled="disabled" type="checkbox" v-model="allSelected" :value="true")
              span
      div(
        v-if="alwaysOpen === true || showListItems"
      ).customSelect__list.cuscroll.open.list
        e-perfect-scrollbar
          ul
            li(
              v-for="item, index in showedSuggestions"
              @click.stop.prevent="toggleItemInCheckbox(item)"
              :key="item[valueKey]"
            )
              label(v-if="checkBoxOnLeft").checked.checkbox-on-left
                input.checkbox(:disabled="disabled" type="checkbox" v-model="model[name]" :value="item[valueKey]")
                span
              div
                span(v-html="item[nameKey]")
              label(v-if="!checkBoxOnLeft").checked
                input.checkbox(:disabled="disabled" type="checkbox" v-model="model[name]" :value="item[valueKey]")
                span
      div(v-else-if="listOpened && !allowGetSuggestions").customSelect__list.cuscroll.open.help
        ul
          li
            div
              div.small Введите минимум {{minSuggestLen}} символа

      div(v-if="showTags && alwaysOpen === false").customSelect__tags-area.cuscroll
        e-perfect-scrollbar
          div.tags-wrapper
            template(v-for="id, index in model[name]")
              div.customSelect__tag {{getItemName(id)}}
                span(v-if="!disabled" @click="removeItem(id, index)").close.close--small
</template>

<script>
  import world from '../../utils/word.js'
  import userFriendlyEr from '../../utils/userFriendlyEr.js'

  export default {
    name: 'e-suggestion-multiselect',
    data() {
      this.list = null
      this.cachedSuggestions = []
      return {
        searchedValue: '',
        leaveArea: false,
        error: null,
        listOpened: false,
        suggestInterval: null,
        hideSuggest: true,
        suggestions: [],
        allSelected: false
      }
    },
    props: {
      showTags: {
        type: Boolean,
        default: true
      },
      nameKey: {
        type: String,
        default: 'name'
      },
      valueKey: {
        type: String,
        default: 'id'
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: 'Начните вводить текст...'
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validationRule: {
        type: String,
        default: 'string'
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      suggestDelay: {
        type: Number,
        default: 300
      },
      minSuggestLen: {
        type: Number,
        default: 0
      },
      suggestionEndpoint: {
        type: Function,
        // eslint-disable-next-line
        default: function (ctx, value) {
          return null
        }
      },
      transformSuggestions: {
        type: Function,
        default: function (ctx, data) {
          return data
        }
      },
      useInnerSearch: {
        type: Boolean,
        default: true
      },
      options: {
        type: Array,
        default: function () {
          return []
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      enableSelectAll: {
        type: Boolean,
        default: false
      },
      selectAllOnCreate: {
        type: Boolean,
        default: false
      },
      alwaysOpen: {
        type: Boolean,
        default: false
      },
      useOuterOptionsFilter: {
        type: Boolean,
        default: false
      },
      checkBoxOnLeft: {
        type: Boolean,
        default: false
      },
      dontShowErrorInFinishComponent: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      showListItems () {
        return this.showedSuggestions && this.showedSuggestions.length > 0 && this.listOpened === true
      },
      showedTagIds(){
        return this.model[this.name]
      },
      showedSuggestions() {
        if (this.useOuterOptionsFilter === true) {
          return this.options
        }
        return this.suggestions
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      },
      allowGetSuggestions(){
        if(this.alwaysOpen === true) {
          return true
        }
        if(this.listOpened && this.searchedValue.length >= this.minSuggestLen){
          return true
        }
        return false
      },
    },
    watch: {
      'options': 'onOptions'
    },
    created () {
      if(this.formValidator){
        this.formValidator.subscribeInput(this)
      }
      if (this.alwaysOpen === true) {
        this.onInput()
      }
      if(Array.isArray(this.model[this.name]) === false) {
        this.model[this.name] = []
      }
      if(this.selectAllOnCreate) {
        this.selectAll()
      }
      this.checkSelections()

      window.addEventListener('click', this.outerClick)
    },
    destroyed(){
      window.removeEventListener('click', this.outerClick)

      if(this.formValidator){
        this.formValidator.unsubscribeInput(this)
      }
    },
    methods: {
      getElement () {
        return this.$refs.suggestion
      },
      onOptions () {
        if (this.enableSelectAll === true) {
          if (this.model[this.name] && this.model[this.name].length < this.options.length) {
            this.allSelected = false
          }
        }
      },
      selectAll () {
        console.log('selectAll')
        if (this.allSelected) {
          this.model[this.name] = []
          this.allSelected = false
        } else {
          this.model[this.name] = this.options.map(v => v[this.valueKey])
          this.allSelected = true
        }
      },
      toggleItemInCheckbox (item) {
        let itemId = item[this.valueKey]
        let index = this.model[this.name].findIndex(v => v === itemId)
        if (index > -1) {
          this.removeItem(item, index)
        } else {
          this.model[this.name].push(itemId)
        }
        this.checkSelections()
      },
      outerClick(){
        this.listOpened = false
        this.$forceUpdate()
      },
      toggleList(){
        this.listOpened = !this.listOpened
      },
      onEnter(){
        this.$emit('enter', this.model[this.name])
      },
      onClick(){
        this.toggleList()
        this.$emit('click', this.model[this.name])

        this.onInput()
      },
      selectItem (item) {
        this.$emit('selectItem', item)
        this.$emit('change', item)
        this.checkSelections()
      },
      checkSelections () {
        setTimeout(() => {
          if (this.options.length > this.model[this.name].length) {
            this.allSelected = false
          } else if (this.options.length === this.model[this.name].length){
            this.allSelected = true
          }
          this.$forceUpdate()
        }, 0)
      },
      removeItem(item, index){
        this.$emit('removeItem', item)
        this.model[this.name].splice(index, 1)
        this.$emit('change', item)
        this.checkSelections()
      },
      getItemName(id){
        let name = null
        const options = this.options
        // search in options
        let v = {}
        for (let i = 0; i < options.length; i++) {
          v = options[i]
          if (v[this.valueKey] === id) {
            name = v[this.nameKey]
            break
          }
        }
        // search in early ajax fetched items
        if (name === null) {
          let v = {}
          for (let i = 0; i < this.cachedSuggestions.length; i++) {
            v =  this.cachedSuggestions[i]
            if (v[this.valueKey] === id) {
              name = v[this.nameKey]
              break
            }
          }
        }
        return name || 'неизвестный тэг'
      },
      onFocus(){
        // this.listOpened = true
        this.$emit('focus', this.model[this.name])
      },
      updateSuggestionsFromEndpoint(url){
        let data = this.$store.getters.readUrlEndpoint(url)
        if (data) {
          this.suggestions = this.searchFilter(this.transformSuggestions(this, data))
          this.cachedSuggestions = [
            ...this.cachedSuggestions,
            ...this.suggestions
          ]
        } else{
          this.suggestions = []
        }
      },
      searchData (data, q) {
        let list = []
        this.error = null
        try {
          let regExp = world.getRegExp(q, 'i')
          list = data.filter((item) => {
            return (item[this.nameKey].search(regExp) > -1 || (item.short_name && item.short_name.search(regExp) > -1))
          })
        } catch (e) {
          console.error(e)
          this.error = e.toString()
        }
        return list
      },
      searchFilter (data) {
        if (this.useInnerSearch) {
          let founded = this.searchData(data, this.searchedValue || '')
          if (founded.length === 0) {
            founded = this.searchData(data, world.engToRus(this.searchedValue || ''))
          }
          return founded
        } else {
          return data
        }
      },
      onInput(){
        if(this.suggestInterval){
          clearInterval(this.suggestInterval)
        }

        if(this.allowGetSuggestions){
          this.$emit('search-change', this.model[this.name])
          let endpoint = this.suggestionEndpoint(this, this.model[this.name], this.searchedValue)
          if(endpoint){
            // get from cache if exist
            let data = this.$store.getters.readUrlEndpoint(endpoint)
            if (data) {
              this.error = null
              this.updateSuggestionsFromEndpoint(endpoint)
            }
            // update cache
            this.suggestInterval = setInterval(()=>{
              this.error = null
              this.$store.dispatch('updateUrlEndpoint', {
                endpoint,
                params: {
                  disableGlobalError: true
                }
              }).then(() => {
                this.updateSuggestionsFromEndpoint(endpoint)
              }).catch(e => {
                console.error(e)
                this.error = userFriendlyEr.recognize(e, endpoint)
              })

              clearInterval(this.suggestInterval)
            }, this.suggestDelay)
          }else{
            this.suggestions = this.searchFilter(this.options)
          }
          return true
        }

        this.suggestions = []
        return false
      },
      validate () {
        let msg = ''
        if (this.required) {
          if(!this.model[this.name] || this.model[this.name].length < 1){
            msg+= 'Заполните поле'
          }
        }

        return {
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement()
        }
      }
    }
  }
</script>
